import icon from "icons/solid/notebook.svg";
import Icon from "hardcover-ui/components/Icon";
import Text from "hardcover-ui/components/Text";
import Plaintext from "components/shared/Plaintext";
import { ReadingJournalEventProps } from "./types";

export default function Note({ journal }: ReadingJournalEventProps) {
  return (
    <div>
      <Text variant="secondary" className="flex flex-row items-center gap-2">
        <Icon icon={icon} />
        <span>Saved a Note</span>
      </Text>
      <Plaintext text={journal.entry} className="mt-4" />
    </div>
  );
}
